import { ToolsUI } from "./ToolsUI";
import { StandardProps } from "../componentMap";
import {
  ensureIsActive,
  ensureIsActiveVariant,
} from "../../utils/product/ensureIsActive";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { Variant } from "../../types/types";
import { isFutureRelease } from "../../utils/variant/isFutureRelease";
import { isAvailableToPreOrder } from "../../utils/variant/isAvailableToPreOrder";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";

export function Tools({
  product,
  runtimeConfig,
  configProps,
}: Pick<StandardProps, "product" | "runtimeConfig" | "configProps">) {
  const { variant, isSelected } = useVariant(product);
  const {
    storeStockScriptUrl,
    stockApiBaseUrl,
    stockApiKey,
    storeStockApiKey,
    storeStockModalApiUrl,
  } = runtimeConfig;
  // TODO WA-340: this is invalid for a RetiredStaticBundle as they don't have a canonicalUrl
  const { canonicalURL } = variant;
  const activeVariant = ensureIsActiveVariant(variant);
  const isVariantInStoreOnly = !!activeVariant && isInStoreOnly(activeVariant);

  const canonicalPath = `https://www.johnlewis.com${canonicalURL}`;

  let buttons;

  if (Array.isArray(configProps?.buttons)) {
    buttons = configProps?.buttons || [];
  }

  return (
    <ToolsUI
      title={variant.title}
      displayCode={variant.displayCode}
      isFutureRelease={isFutureRelease(variant)}
      isPreOrderable={isAvailableToPreOrder(variant)}
      skuId={getSkuId(variant)}
      isActiveProduct={!!ensureIsActive(product)}
      buttons={buttons}
      shareUrl={canonicalPath}
      shareImage={variant.images.primary}
      storeStockApiKey={storeStockApiKey}
      storeStockScriptUrl={storeStockScriptUrl}
      stockApiBaseUrl={stockApiBaseUrl}
      stockApiKey={stockApiKey}
      isVariantSelected={isSelected}
      isStoreStockOnly={isVariantInStoreOnly}
      storeStockModalApiUrl={storeStockModalApiUrl}
    />
  );
}

function getSkuId(variant: Variant) {
  if (
    variant.__typename === "StaticBundleVariant" ||
    variant.__typename === "RetiredStaticBundleVariant"
  ) {
    // @ts-ignore
    return variant.components[0].variant.aliases.skuId;
  }

  return variant.aliases.skuId;
}
